import { ICreateNewChatInitialValues } from './types';
import * as Yup from 'yup';

export const createNewChatDialogInitialValues: ICreateNewChatInitialValues = {
  message: '',
};

export const createNewChatValidationSchema = Yup.object().shape({
  message: Yup.string().required('Required'),
});
